import React, { Component, ReactNode } from 'react';
import { Snackbar } from '@mui/material';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  open: boolean;
}

class CopilotErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, open: false };
  }

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true, open: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error('[GlobalCopilot] Error caught:', error, errorInfo);
  }

  handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    if (this.state.hasError) {
      return (
        <>
          {this.props.children}
          <Snackbar
            open={this.state.open}
            autoHideDuration={6000}
            onClose={this.handleClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            sx={{ zIndex: 2147483647 }}
            message="An error has occurred. Please refresh and try again."
          />
        </>
      );
    }

    return this.props.children;
  }
}

export default CopilotErrorBoundary;
